import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App2 from './App2';
import * as serviceWorker from './serviceWorker';

// Use the new React 18 createRoot API
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App2 />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
